import React, { useState } from "react";
import { Check } from "lucide-react";
import { Input } from "../ui/input";
import { QUESTIONS } from "../../constants/testIds";

export default function SmartQuestionCard({ question, onSelect, disabled }) {
  const [text, setText] = useState("");
  const [selected, setSelected] = useState(null);
  if (!question) return null;

  const isText =
    question.type === "short_text" ||
    question.options?.some((o) => o.value === "__text__") ||
    ["country_clarification", "port_clarification"].includes(question.type);

  const handleOption = (opt) => {
    if (disabled) return;
    if (opt.value === "__text__") {
      setSelected("__text__");
      return;
    }
    setSelected(opt.value);
    onSelect(opt.value);
  };

  const submitText = () => {
    const v = text.trim();
    if (!v) return;
    onSelect(v);
  };

  return (
    <div data-testid={QUESTIONS.card} className="card-panel p-6 sm:p-8 space-y-6 shadow-glow">
      <h2 className="text-2xl sm:text-3xl font-light tracking-tight text-neutral-900 leading-snug">
        {question.question}
      </h2>

      {question.options?.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {question.options.map((opt) => {
            const key = typeof opt.value === "object" ? opt.label : String(opt.value);
            const isSelected = selected === opt.value || selected === key;
            return (
              <button
                key={key}
                type="button"
                disabled={disabled}
                data-testid={`${QUESTIONS.option}-${opt.label.replace(/\s+/g, "-")}`}
                onClick={() => handleOption(opt)}
                className={`text-left p-5 rounded-lg border cursor-pointer transition-all duration-300 ease-out ${
                  isSelected
                    ? "border-[hsl(var(--brand-navy))] bg-[hsl(var(--brand-navy))] text-white shadow-glow scale-[1.02]"
                    : "border-neutral-200 bg-white hover:border-[hsl(var(--brand-red))]/50 hover:shadow-lift hover:-translate-y-1 hover:bg-[hsl(var(--brand-red))]/[0.02]"
                }`}
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="font-medium">{opt.label}</span>
                  {isSelected && <Check className="w-4 h-4 shrink-0" />}
                </div>
              </button>
            );
          })}
        </div>
      )}

      {(question.type === "short_text" || selected === "__text__" || (isText && !question.options?.length)) && (
        <div className="space-y-3 pt-2">
          <Input
            data-testid={QUESTIONS.textInput}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submitText()}
            placeholder="Type your answer"
            className="field-input h-14 text-lg"
            disabled={disabled}
          />
          <button
            type="button"
            data-testid={QUESTIONS.nextBtn}
            disabled={disabled || !text.trim()}
            onClick={submitText}
            className="btn-wizard-primary disabled:opacity-50"
          >
            Continue
          </button>
        </div>
      )}
    </div>
  );
}
